import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FlowerGirl } from 'src/public/ds/illustrations/flower-girl.svg';
import { navigationService } from 'src/config/rootService';
import { analyticsClient } from 'src/shared/services/analytics';
import { useSelector } from 'react-redux';
import { getIsRecheckingEligibility } from 'src/modules/user/selectors/userSelectors';
import {
    ButtonGroup,
    Button,
    HeadingText50,
    BodyTextMedium,
    pxToRem,
} from '@modernhealth/vital-components';

export enum ExtendTherapySessionsPageTestID {
    Wrapper = 'ExtendTherapySessionsPageTestID.Wrapper',
    BackToHome = 'ExtendTherapySessionsPageTestID.BackToHome',
    Next = 'ExtendTherapySessionsPageTestID.Next',
}

const PageContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: pxToRem(524),
    marginTop: '3rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: '3rem',
});

const StyledFlowerGirl = styled(FlowerGirl)({
    marginBottom: '2rem',
});

const TextContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '100%',
});

export const ExtendTherapySessionsPage = () => {
    const { t } = useTranslation();
    const isRecheckingEligibility = useSelector(getIsRecheckingEligibility);

    return (
        <PageContainer data-testid={ExtendTherapySessionsPageTestID.Wrapper}>
            <StyledFlowerGirl />
            <TextContainer>
                <HeadingText50>{t('insuranceForm:extended_therapy_access.title')}</HeadingText50>
                <BodyTextMedium marginBottom={18}>
                    {isRecheckingEligibility
                        ? t('insuranceForm:extended_therapy_access.description_recheck')
                        : t('insuranceForm:extended_therapy_access.description')}
                </BodyTextMedium>
                <BodyTextMedium marginBottom={24}>
                    {isRecheckingEligibility
                        ? t('insuranceForm:extended_therapy_access.instructions_recheck')
                        : t('insuranceForm:extended_therapy_access.instructions')}
                </BodyTextMedium>
            </TextContainer>
            <ButtonGroup css={{ width: '100%' }}>
                <Button
                    variant="secondary"
                    size="large"
                    fluid
                    onClick={() => navigationService.navigate('/dashboard')}
                >
                    {t('insuranceForm:extended_therapy_access.back_to_home')}
                </Button>
                <Button
                    variant="primary"
                    size="large"
                    fluid
                    onClick={() => {
                        analyticsClient.trackClick('Extend Therapy Sessions: Extend', {
                            page_name: 'Final session booked',
                        });
                        navigationService.navigate('/inquire-employer-insurance-coverage');
                    }}
                >
                    {isRecheckingEligibility
                        ? t('insuranceForm:extended_therapy_access.recheck_eligibility')
                        : t('insuranceForm:extended_therapy_access.extended_therapy_access')}
                </Button>
            </ButtonGroup>
        </PageContainer>
    );
};
